import React from "react";
import axios from "axios";
import styles from "./Register.module.css";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { saveTokenTask } from "../../../redux/userSlice";
import { toast } from "react-toastify";

function Register() {
  const register = () => toast.success("Start Shopping!");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [cellphone, setCellphone] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_API_URL}/users`,
        method: "POST",
        data: {
          firstname,
          lastname,
          cellphone,
          password,
          password2,
          email,
        },
      });
      if (response) {
        navigate("/");
        register();
        return dispatch(saveTokenTask(response.data));
      }
    } catch (error) {
      setMessage(error.response.data.msg);
    }
  };

  return (
    <div className={styles.body_background}>
      <div className="container">
        <div className={styles.row + " row"}>
          <div className={styles.leftCol + " col"}></div>
          <div className={styles.rightCol + " col"}>
            <Link className={styles.home_link} to="/">
              <p className={styles.return}>
                <i className="me-1 fa-solid fa-arrow-left-long"></i>Home
              </p>
            </Link>
            <div className={styles.formRegister}>
              <form
                className="p-3 mb-2"
                encType="multipart/form-data"
                action=""
                onSubmit={handleSubmit}
              >
                <h3
                  className={"modal-title " + styles.register_title}
                  id="formModalLabel"
                >
                  Sign up
                </h3>
                <p>A smooth sea never made a skillful sailor</p>
                <div className="form-group mt-2">
                  <label
                    htmlFor="firstname"
                    className={styles.label + " form-label mb-1"}
                  >
                    Firstname *
                  </label>
                  <input
                    value={firstname}
                    type="text"
                    name="firstname"
                    className={styles.form_font + " form-control"}
                    onChange={(event) => setFirstname(event.target.value)}
                  />
                </div>
                <div className="form-group mt-2">
                  <label
                    htmlFor="lastname"
                    className={styles.label + " form-label mb-1"}
                  >
                    Lastname *
                  </label>
                  <input
                    value={lastname}
                    type="text"
                    name="lastname"
                    className={styles.form_font + " form-control"}
                    onChange={(event) => setLastname(event.target.value)}
                  />
                </div>
                <div className="form-group mt-2">
                  <label
                    htmlFor="email"
                    className={styles.label + " form-label mb-1"}
                  >
                    Email *
                  </label>
                  <input
                    value={email}
                    type="email"
                    name="email"
                    className={styles.form_font + " form-control"}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                </div>
                <div className="form-group mt-2">
                  <label
                    htmlFor="lastname"
                    className={styles.label + " form-label mb-1"}
                  >
                    Phone number
                  </label>
                  <input
                    value={cellphone}
                    type="text"
                    name="cellphone"
                    className={styles.form_font + " form-control"}
                    onChange={(event) => setCellphone(event.target.value)}
                  />
                </div>
                <div className="form-group mt-2">
                  <label
                    htmlFor="lastname"
                    className={styles.label + " form-label mb-1"}
                  >
                    Password *
                  </label>
                  <input
                    value={password}
                    type="password"
                    name="password"
                    className={styles.form_font + " form-control"}
                    id="password"
                    onChange={(event) => setPassword(event.target.value)}
                  />
                </div>
                <div className="form-group mt-2">
                  <label
                    htmlFor="lastname"
                    className={styles.label + " form-label mb-1"}
                  >
                    Repeat password *
                  </label>
                  <input
                    value={password2}
                    type="password"
                    name="password2"
                    className={styles.form_font + " form-control"}
                    id="password2"
                    onChange={(event) => setPassword2(event.target.value)}
                  />
                </div>
                <button
                  type="submit"
                  className={"btn mt-4 " + styles.sign_up_btn}
                >
                  Sign up
                </button>
                <p className="text-danger py-2">{message}</p>
              </form>
              <p className={styles.linkToLogin}>
                Already have an account?{" "}
                <span>
                  <Link to="/login" className={styles.login}>
                    Login
                  </Link>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
